exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".license .dna {\n  color: #666666;\n  font-size: 14px;\n  padding: 10px 0 14px;\n  border-bottom: 1px dashed #e8eaea;\n  font-weight: bold; }\n\n.license .text {\n  margin-top: 16px;\n  color: #999999;\n  font-size: 14px; }\n  .license .text.no-title {\n    margin-top: 0; }\n  .license .text .license-sup {\n    line-height: 1.6; }\n  .license .text .license-link {\n    color: #00816a;\n    text-decoration: underline; }\n  .license .text .details {\n    padding-left: 20px;\n    margin-top: 10px; }\n    .license .text .details li {\n      line-height: 1.6; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader!./src/app/common/license/license.scss
// module id = 626
// module chunks = 3